/**
 * Convert 2-letter country code to flag emoji
 * e.g. "DK" → 🇩🇰, "DE" → 🇩🇪
 */
export const countryToFlag = (code) => {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(
    ...code.toUpperCase().split('').map(c => c.charCodeAt(0) + 127397)
  );
};

/** All supported countries for the selector */
export const EUROPEAN_COUNTRIES = [
  { code: 'AL', name: 'Albanien' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenien' },
  { code: 'AU', name: 'Australien' },
  { code: 'AZ', name: 'Aserbajdsjan' },
  { code: 'AT', name: 'Østrig' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BA', name: 'Bosnien-Hercegovina' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'CA', name: 'Canada' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'CY', name: 'Cypern' },
  { code: 'CZ', name: 'Tjekkiet' },
  { code: 'DK', name: 'Danmark' },
  { code: 'EE', name: 'Estland' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'Frankrig' },
  { code: 'GE', name: 'Georgien' },
  { code: 'DE', name: 'Tyskland' },
  { code: 'GR', name: 'Grækenland' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'IS', name: 'Island' },
  { code: 'IN', name: 'Indien' },
  { code: 'IE', name: 'Irland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italien' },
  { code: 'JP', name: 'Japan' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'LV', name: 'Letland' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Litauen' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MA', name: 'Marokko' },
  { code: 'MT', name: 'Malta' },
  { code: 'MX', name: 'Mexico' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'NL', name: 'Holland' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'MK', name: 'Nordmakedonien' },
  { code: 'NO', name: 'Norge' },
  { code: 'PL', name: 'Polen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Rumænien' },
  { code: 'RU', name: 'Rusland' },
  { code: 'SM', name: 'San Marino' },
  { code: 'RS', name: 'Serbien' },
  { code: 'SK', name: 'Slovakiet' },
  { code: 'SI', name: 'Slovenien' },
  { code: 'ZA', name: 'Sydafrika' },
  { code: 'ES', name: 'Spanien' },
  { code: 'SE', name: 'Sverige' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TR', name: 'Tyrkiet' },
  { code: 'AE', name: 'UAE' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'GB', name: 'Storbritannien' },
  { code: 'US', name: 'USA' },
  { code: 'VA', name: 'Vatikanstaten' },
];
